import {Button, Form} from "react-bootstrap";
import MyCard from "../components/myCard";
import React from "react";
import {Controller, useForm} from "react-hook-form";
import FormGroup from "../components/formGroup";
import MySelect from "../components/form/mySelect";
import {isObject} from "lodash";
import MyFile from "../components/myFile";

function RemiseMemoire(props: { onSubmit: Function, secondeSession: boolean, parameters: Object }) {
    const {register, control, handleSubmit, formState, getValues} = useForm();
    const onSubmit = data => props.onSubmit(data, props.secondeSession);

    const ZoneMemoire = (<>
        <p>
            Par le fait de déposer mon mémoire électroniquement, je déclare avoir pris connaissance et
            respecté les modalités de citations des sources référencées dans le document
            « Normes de rédaction d’un travail scientifique » (disponible sur MOODLE).
        </p>

        {!props.secondeSession && <FormGroup as={"textarea"}
                                             required={true}
                                             label={"Titre définitif"}
                                             {...register("MemoireTitreDefinitif", {required: true, maxLength: 1000})}
        />}

        {!props.secondeSession && <Controller name={"DisciplineMemoireID"}
                                              value={getValues("DisciplineMemoireID") !== undefined ? (isObject(getValues("DisciplineMemoireID"))
                                                  ? getValues("DisciplineMemoireID").value
                                                  : props.parameters.DisciplineMemoireID.find(f => f.value === getValues("DisciplineMemoireID").value)) : undefined}
                                              rules={{required: true}}
                                              render={({field}) => <FormGroup
                                                  {...field}
                                                  errors={formState.errors.DisciplineMemoireID}
                                                  required={true}
                                                  label={"Discipline du mémoire"}
                                                  type={MySelect}
                                                  options={props.parameters.DisciplineMemoireID}
                                              />}
                                              control={control}
        />}

        <Controller name={"MemoireFichierMemoireAvecAnnexesID"}
                    rules={{required: true}}
                    render={({field}) => <MyFile
                        {...field}
                        required={true}
                        label={"Mémoire avec annexes (max. 40MB)"}
                    />}
                    control={control}/>

        <Controller name={"MemoireFichierMemoireSansAnnexesID"}
                    rules={{required: true}}
                    render={({field}) => <MyFile
                        {...field}
                        required={true}
                        label={"Mémoire sans annexe (max. 40MB)"}
                    />}
                    control={control}/>
    </>);

    return (
     <Form noValidate validated={(formState.isSubmitting || formState.isSubmitted) && !formState.isValid}
           onSubmit={handleSubmit(onSubmit)}>
            <MyCard header={`Remise du mémoire`}
                    /*  <MyCard header={`Remise du mémoire ${props.secondeSession ? "en seconde session" : ""}`} */
                    body={ZoneMemoire}/>
         <br/>
         <Button type="submit" variant="success" size={"lg"} block>
             Sauvegarder
         </Button>
     </Form>
    );
}

export default RemiseMemoire;